import { render } from "./edit-content.vue?vue&type=template&id=2dba7df2"
import script from "./edit-content.vue?vue&type=script&lang=js"
export * from "./edit-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__